import { useEffect, useState } from "react";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";

const PAGE_SIZE = 50;

// Shared fetch-a-page hook for the common "filters -> table" list screens
// (Pagination Across All List Screens, Sep 2026). Resets to page 1
// whenever the filter params change so a user never lands on an empty page.
export function usePaginatedList(endpoint, params) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [reloadToken, setReloadToken] = useState(0);
  const paramsKey = JSON.stringify(params);

  useEffect(() => {
    setPage(1);
  }, [paramsKey]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    client
      .get(endpoint, { params: { ...params, page, page_size: PAGE_SIZE } })
      .then((res) => {
        if (!active) return;
        setItems(res.data.items);
        setTotalPages(res.data.total_pages);
        setTotal(res.data.total);
      })
      .catch((err) => active && toast.error(getErrorMessage(err)))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, page, paramsKey, reloadToken]);

  return { items, setItems, loading, page, setPage, totalPages, total, reload: () => setReloadToken((t) => t + 1) };
}
